export async function index() {
  const data = await this.$adminRepositories.payment_confirms.index();
  return data;
}

export async function update({}, payload) {
  const data = await this.$adminRepositories.payment_confirms.update(payload);
  return data;
}
